import { Trans, useTranslation } from "react-i18next";
import {
  ListItem,
  PrivacyPolicyText,
  SectionContainer,
  SectionSubTitle,
  SectionSubTitle2,
  SectionTitle,
  SubSectionContainer,
} from "../PrivacyPolicyContent.styled";

export const CookiesSectionContent = (props: CookiesSectionContentProps) => {
  const { i18n } = useTranslation();

  return (
    <SectionContainer>
      <SectionTitle>
        <Trans i18nKey={"privacyPolicy.cookies.title"} />
      </SectionTitle>
      <PrivacyPolicyText>
        <Trans i18nKey={"privacyPolicy.cookies.text"} />
      </PrivacyPolicyText>
      <SectionSubTitle2>
        <Trans i18nKey={"privacyPolicy.cookies.browserCookiesSubtitle"} />
      </SectionSubTitle2>
      <PrivacyPolicyText>
        <Trans i18nKey={"privacyPolicy.cookies.browserCookiesText"} />
      </PrivacyPolicyText>
      <SectionSubTitle>
        <Trans i18nKey={"privacyPolicy.cookies.subtitle"} />
      </SectionSubTitle>
      <SubSectionContainer>
        <SectionSubTitle2>
          <Trans i18nKey={"privacyPolicy.cookies.sessionCookiesTitle"} />
        </SectionSubTitle2>
        <div>
          {(
            i18n.t("privacyPolicy.cookies.sessionCookiesList", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <ListItem
              key={index}
              dangerouslySetInnerHTML={{ __html: definition }}
            />
          ))}
        </div>
      </SubSectionContainer>
      <SubSectionContainer>
        <SectionSubTitle2>
          <Trans i18nKey={"privacyPolicy.cookies.persistentCookiesTitle"} />
        </SectionSubTitle2>
        <div>
          {(
            i18n.t("privacyPolicy.cookies.persistentCookiesList", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <ListItem
              key={index}
              dangerouslySetInnerHTML={{ __html: definition }}
            />
          ))}
        </div>
      </SubSectionContainer>
      <SubSectionContainer>
        <SectionSubTitle2>
          <Trans i18nKey={"privacyPolicy.cookies.functionalityCookiesTitle"} />
        </SectionSubTitle2>
        <div>
          {(
            i18n.t("privacyPolicy.cookies.functionalityCookiesList", {
              returnObjects: true,
            }) as string[]
          ).map((definition, index) => (
            <ListItem
              key={index}
              dangerouslySetInnerHTML={{ __html: definition }}
            />
          ))}
        </div>
      </SubSectionContainer>
    </SectionContainer>
  );
};

export interface CookiesSectionContentProps {}
